import { put, select, take } from 'redux-saga/effects';
import { getFormValues } from 'redux-form/immutable';
import { push } from 'redux-little-router';
import { updateDraft } from 'modules/Taps/components/NDFL3Light/redux/actions';
import { UPDATE_DRAFT_SUCCESS } from 'modules/Taps/components/NDFL3Light/redux/actionTypes';
import { STEP_INCOME_FORM } from '../constants';
import { isApplicableSource } from 'modules/Taps/components/NDFL3LightRentalIncome/helpers';

/** @typedef { import('immutable').List } List */

export function* submitIncomesSaga({ payload: { getNextStep } }) {
  const formData = yield select(getFormValues(STEP_INCOME_FORM));
  const formSources = updateRentalSourceFIOIn(formData.getIn(['payload', 'sheetA', 'sources']));

  yield put(
    updateDraft({
      draft: formData
        .set('currentFormId', 'submit')
        .setIn(['payload', 'sheetA', 'sources'], formSources),
    }),
  );

  yield take(UPDATE_DRAFT_SUCCESS);

  yield put(push({ query: { step: getNextStep() } }, { persistQuery: true }));
}

/**
 * Set default title for the source sourceOther.fioIn field
 * @param sources
 * @returns {List}
 */
function updateRentalSourceFIOIn(sources) {
  let sourceIndex = getMaxGenericFIOIndex(sources);

  return sources.map((source) => {
    if (isApplicableSource(source) && !source.getIn(['sourceOther', 'fioIn'])) {
      sourceIndex++;
      return source.setIn(['sourceOther', 'fioIn'], `Источник дохода ${sourceIndex}`);
    }
    return source;
  });
}

/**
 * Get max index of Income source default title
 * @param sources
 * @returns {number}
 */
function getMaxGenericFIOIndex(sources) {
  const genericFioRegExp = /^Источник дохода (\d+)/;
  let sourceIndex = 0;

  sources.forEach((source) => {
    const fioIn = source.getIn(['sourceOther', 'fioIn']);
    if (!fioIn) {
      return;
    }
    const [, id] = fioIn.match(genericFioRegExp) || [];

    if (typeof id !== 'undefined') {
      sourceIndex = Math.max(sourceIndex, id);
    }
  });

  return sourceIndex;
}
